import * as actionTypes from "../actions/IncidentPreventionActions";

const initialState = {
  Loading: false,

  incidentPreventionActionList: [],

  getUser: [],
  incidentPreventionActionRecord: [],
  incidentPreventionActionDropdownList: [],
  workspaceAttachmentList: [],
  validation_error: "",
  attachment_validation_error: "",
  redirect_to_list: false,
  showDeleteModel: false,
  showUpdateForm: false,
  showViewPage: false,
  closeModal: false,
  session: null, // Add session state
};
const IncidentPreventionActionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INCIDENT_PREVENTION_ACTION_REQUEST:
      return {
        ...state,
        Loading: true,
        validation_error: "",
        redirect_to_list: false,
      };

    case actionTypes.INCIDENT_PREVENTION_ACTION_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        incidentPreventionActionList: action.incidentPreventionActionList,
        showUpdateForm: false,
        showViewPage: false,
        incidentPreventionActionRecord: [],
      };

    case actionTypes.INCIDENT_PREVENTION_ACTION_SERVER_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: "",
        showUpdateForm: false,
        showViewPage: false,
        incidentPreventionActionRecord: [],
      };
    case actionTypes.INCIDENT_PREVENTION_ACTION_GET_SUCCESS:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        incidentPreventionActionRecord: action.record,
        showUpdateForm: action.actionType === "update" ? true : false,
        showViewPage: action.actionType === "view" ? true : false,
      };
    case actionTypes.INCIDENT_PREVENTION_ACTION_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        Loading: false,
        incidentPreventionActionDropdownList: action.scopesDropdownList,
      };
    case actionTypes.INCIDENT_PREVENTION_ACTION_VALIDATION_ERROR:
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.HIDE_INCIDENT_PREVENTION_ACTION_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.feild_key])
        delete state.validation_error[action.feild_key];
      return {
        ...state,
        Loading: false,
        redirect_to_list: false,
        validation_error: action.validation_error,
      };
    case actionTypes.REDIRECT_TO_INCIDENT_PREVENTION_ACTION_LIST:
      return {
        ...state,
        redirect_to_list: true,
        showUpdateForm: false,
        showViewPage: false,
        validation_error: "",
        incidentPreventionActionRecord: [],
      };

    default:
      return state;
  }
};

export default IncidentPreventionActionReducer;
